import { ProductList } from '../../ProductList';

export const TourList: React.FC = () => <ProductList resource="tour" />;
